export default function isTenantUser(user) {
    return Number(user?.user_type) === 3 && !!user?.tenant_id;
}
